// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth,  setPersistence, browserLocalPersistence} from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyDJtHc68DHNNkNUOmpv4lLrhQPdwtcYWB0",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "riitii-tt-fb.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "riitii-tt-fb",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "riitii-tt-fb.firebasestorage.app",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:57274430960:android:d83835add954f96c855935",
};

// Initialize Firebase App
const app = initializeApp(firebaseConfig);

// Initialize Auth
export const auth = getAuth(app);

// PERSIST LOGIN SESSION ON WEB
// (Critical for admin dashboard & axios interceptor)
setPersistence(auth, browserLocalPersistence).catch(() => {});